import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";

const FileTabCard = styled(Card)(() => ({
  display: "flex",
  marginBottom: 10,
  minWidth: "100%",
}));

export default FileTabCard;
